// extracted by mini-css-extract-plugin
export default {"status":"BroadbandUsage_status__r66-v"};